import { combineReducers, } from 'redux';
import { createReducer, } from 'typesafe-actions';

import { fetchExamples, } from './actions';

const exampleInitialState = {
    isLoading: false,
    error: false,
    errorMessage: null,
    data: [],
};

const examplesReducer = createReducer(exampleInitialState)
    .handleAction(fetchExamples.request, (state,) => ({ ...state, isLoading: true }))
    .handleAction(fetchExamples.success, (state, action) => ({
        ...state,
        isLoading: false,
        error: false,
        data: action.payload,
    }))
    .handleAction(fetchExamples.failure, (state, action) => ({
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload,
    }));

export default combineReducers({
    list: examplesReducer,
});
